import React from "react";

const style = {
  gradientBar: {
    padding: "0",
    lineHeight: "27px",
    height: "31px",
    overflow: "hidden",
    marginBottom: "2px",
  },
  gradientBarEmpty: {
    color: "#aaa",
  },
  gradientBarColors: {
    color: "#fff",
    textShadow: "1px 1px 2px rgba(0,0,0,.75)",
    borderRadius: "5px",
    marginBottom: "2px",
    boxShadow:
      "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -15px, rgba(0, 0, 0, 0.2) 0px -4px 0px inset",
  },
  reagentName: {
    cursor: "pointer"
  },
  resultContainer: {
    // cursor: "pointer", // Makes dosage axis clickable
  },
  hint: {
    textAlign: "right",
    fontSize: "0.8em",
    color: "gray",
  },
};

const cssBackground = (hexes, isReacting) => {
  if (isReacting !== true) return { background: "rgb(191, 191, 191)" };
  if (hexes.length === 0) return {};
  if (hexes.length === 1) return { background: hexes[0] };

  const cssGradient = hexes
    .map((hex, i) => `${hex} ${(100 * i) / hexes.length}%`)
    .join(", ");
  return { background: `linear-gradient(to right, ${cssGradient})` };
};

export default class ReactionColorCircle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: 0,
    };
  }

  componentDidMount() {
    this.updateMaxWidth();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.result !== this.props.result) {
      this.updateMaxWidth();
    }
  }

  
    updateMaxWidth = () => {
      // Measure all .reagentsymbol-full elements
      const fullElements = document.querySelectorAll(".reagentsymbol-full");
    
      // If no elements are found or if all widths are 0, set width to auto
      if (fullElements.length === 0) {
        const allReagentSymbols = document.querySelectorAll(".testdrugs-color-circle-reagentsymbol");
        allReagentSymbols.forEach(el => {
          el.style.width = "auto";
        });
        return;
      }
    
      // Calculate the maximum width
      const maxWidth = Array.from(fullElements)
        .map((el) => el.offsetWidth)
        .reduce((max, width) => Math.max(max, width), 0);
    
      // Apply the maxWidth to all .testdrugs-color-circle-reagentsymbol elements
      const allReagentSymbols = document.querySelectorAll(".testdrugs-color-circle-reagentsymbol");
      allReagentSymbols.forEach((el) => {
        el.style.width = maxWidth > 0 ? `${maxWidth}px` : '20px'; // Set to maxWidth or default to 17px
        el.style.cursor = 'pointer';
        el.style.paddingLeft = '7px';
      });
    
      // Update state if needed for other purposes
      this.setState({ maxWidth });
    }
  
  handleReagentClick(reagentName) {
    const reagentLinks = {
      Marquis: "/marquis-reagent-test-kit/",
      Mq: "/marquis-reagent-test-kit/",
      Mecke: "/mecke-reagent-test-kit/",
      Me: "/mecke-reagent-test-kit/",
      Liebermann: "/liebermann-reagent-test-kit/",
      Li: "/liebermann-reagent-test-kit/",
      Froehde: "/froehde-reagent-test-kit/",
      Fr: "/froehde-reagent-test-kit/",
      Ehrlich: "/ehrlich-reagent-test-kit/",
      Eh: "/ehrlich-reagent-test-kit/",
      Hofmann: "/hofmann-reagent-test-kit/",
      Ho: "/hofmann-reagent-test-kit/",
      Robadope: "/robadope-reagent-test-kit/",
      Ro: "/robadope-reagent-test-kit/",
      "Simon's": "/simons-reagent-test-kit/",
      Si: "/simons-reagent-test-kit/",
      Morris: "/morris-reagent-test-kit/",
      Mo: "/morris-reagent-test-kit/",
      Zimmermann: "/zimmermann-reagent-test-kit/",
      Zi: "/zimmermann-reagent-test-kit/",
      "Cannabis (4-AP)": "/cannabis-reagent-test-kit/",
      Ca: "/cannabis-reagent-test-kit/",
      Scott: "/is-scotts-reagent-reliable/",
      Sc: "/is-scotts-reagent-reliable/",
      Mandelin: "/is-mandelin-reagent-reliable/",
      Ma: "/is-mandelin-reagent-reliable/",
      Folin: "https://en.wikipedia.org/wiki/Folin%27s_reagent",
      Fo: "https://en.wikipedia.org/wiki/Folin%27s_reagent",
      Gallic: "https://en.wikipedia.org/wiki/Gallic_acid_reagent",
      Ga: "https://en.wikipedia.org/wiki/Gallic_acid_reagent",
    };

    if (reagentLinks[reagentName]) {
      window.open(reagentLinks[reagentName], "_blank");
    }
  }
  getDynamicWidth(reagentName) {
    // No specific hardcoded widths, return "auto" by default
    return "auto";
  }

  render() {
    const { result, useShortReagentName, hideReagentNameOnLargeScreen } =
      this.props;
    const hexes = result.colors.map((c) => c.hex);
    let colorBarStyle = {
      ...style.gradientBar,
      ...style.gradientBarColors,
      ...cssBackground(hexes, result.isReacting),
    };
    let info = result.isReacting ? result.hint : result.hint;
    info = result.isDummy ? "no data" : info;
    if (result.isDummy) {
      colorBarStyle = {
        ...style.gradientBar,
        ...style.gradientBarEmpty,
      };
    }

    const topClassName = `testdrugs-reaction-color-circle ${
      hideReagentNameOnLargeScreen
        ? "testdrugs-hide-reagent-name-on-large-screen"
        : ""
    }`;
    const infoClassName = `testdrugs-color-circle-reagentinfo ${
      result.isDummy ? "reagentinfo-no-data" : ""
    }`;

    return (
      <div className={topClassName} style={style.resultContainer}>
        <div style={colorBarStyle}>
          <div className="testdrugs-color-circle-reagentsymbol">
            {/* Full Reagent Name */}
            <span
              className="reagentsymbol-full"
              onClick={() => this.handleReagentClick(result.reagent.fullName)}
              style={{ width: this.getDynamicWidth(result.reagent.fullName) }}
            >
              {result.reagent.fullName}
            </span>

            {/* Short Reagent Name */}
            <span
              className="reagentsymbol-short"
              onClick={() => this.handleReagentClick(result.reagent.shortName)}
              style={{ width: this.getDynamicWidth(result.reagent.shortName) }}
            >
              {result.reagent.shortName}
            </span>
          </div>
          <span className={infoClassName}>{info}</span>
        </div>
      </div>
    );
  }
}
